(function () {
  var MSG_ID = 'ice-cream-rule-msg';
  var MIN_CENTS = 30000;
  var EMAIL = '<a href="mailto:customerservice@exoticsodaco.com">customerservice@exoticsodaco.com</a>';
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function iceOk(n) { return n === 0 || n % 55 === 0; }
  function otherOk(c) { return c === 0 || c >= MIN_CENTS; }
  function messages(n, c) {
    var out = [];
    if (n > 0 && !iceOk(n)) {
      var r = n % 55;
      out.push('<strong>You have ' + n + ' ice cream cases in your cart. Add ' + (55 - r) + ' more cases to reach ' + (n - r + 55) + (n > 55 ? ', or remove ' + r + ' to order ' + (n - r) : '') + '.</strong><br>Ice cream is sold in mixed-flavor orders in multiples of 55 cases: 55 cases $120/case, 110 cases (1 pallet) $90/case, 330+ cases (3 pallets) $70/case. Shipping included. More than 3 pallets? Email ' + EMAIL + ' for pricing.');
    }
    if (c > 0 && !otherOk(c)) {
      out.push('<strong>Soda and snack orders have a ' + money(MIN_CENTS) + ' minimum. Your soda and snacks total ' + money(c) + '. Add ' + money(MIN_CENTS - c) + ' more to check out.</strong><br>Ice cream is not counted toward the ' + money(MIN_CENTS) + ' minimum.');
    }
    return out;
  }
  function targets() {
    return Array.prototype.slice.call(document.querySelectorAll('#checkout, #CartDrawer-Checkout, button[name="checkout"], input[name="checkout"]'));
  }
  function extras() {
    return Array.prototype.slice.call(document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons'));
  }
  var obs;
  function watch() { obs.observe(document.body || document.documentElement, { childList: true, subtree: true }); }
  function apply(n, c) {
    obs.disconnect();
    var msgs = messages(n, c);
    var ok = msgs.length === 0;
    var btns = targets();
    btns.forEach(function (b) {
      if (!ok) { b.setAttribute('disabled', 'disabled'); b.setAttribute('aria-disabled', 'true'); b.style.opacity = '0.45'; b.style.pointerEvents = 'none'; }
      else { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); b.style.opacity = ''; b.style.pointerEvents = ''; }
    });
    extras().forEach(function (e) { e.style.display = ok ? '' : 'none'; });
    var old = Array.prototype.slice.call(document.querySelectorAll('.' + MSG_ID));
    old.forEach(function (o) { o.parentNode && o.parentNode.removeChild(o); });
    if ((n > 0 || c > 0) && btns.length) {
      btns.forEach(function (b) {
        var host = b.parentNode;
        if (!host || host.querySelector('.' + MSG_ID)) return;
        var d = document.createElement('div');
        d.className = MSG_ID;
        d.style.cssText = 'margin:0 0 1rem;padding:1rem;border:1px solid ' + (ok ? '#2e7d32' : '#c62828') + ';border-radius:6px;font-size:1.3rem;line-height:1.5;text-align:left;';
        if (ok) {
          var parts = [];
          if (n > 0) parts.push('Ice cream: ' + n + ' cases');
          if (c > 0) parts.push('Soda and snacks: ' + money(c));
          d.innerHTML = '<strong>Order ready. ' + parts.join(' | ') + '</strong>' + (n > 0 ? '<br>More than 3 pallets of ice cream? Email ' + EMAIL + ' for pricing.' : '');
        } else {
          d.innerHTML = msgs.join('<hr style="margin:0.8rem 0;border:0;border-top:1px solid #ddd">');
        }
        host.insertBefore(d, b);
      });
    }
    watch();
  }
  var busy = false;
  function refresh() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var n = 0, c = 0;
      (cart.items || []).forEach(function (i) {
        if (i.sku && i.sku.indexOf('ICE-') === 0) n += i.quantity;
        else c += (i.final_line_price != null ? i.final_line_price : i.line_price);
      });
      apply(n, c);
    }).catch(function () {}).then(function () { busy = false; });
  }
  var timer;
  function later() { clearTimeout(timer); timer = setTimeout(refresh, 350); }
  document.addEventListener('DOMContentLoaded', refresh);
  if (document.readyState !== 'loading') refresh();
  obs = new MutationObserver(later);
  watch();
})();